/* Brand My Cap: multi-select Style + Colour filter for collection pages.
   Uses style-* / colour-* product tags. OR within a group, AND between groups.
   URL: ?style=trucker-caps,beanies&colour=black,navy
   Caps always come first (price low to high within each group), then hats, buckets and visors, then beanies,
   then scarves, buffs, gloves and accessories. Fee/helper products are never listed. */
(function () {
  if (window.__bmcFilter) return;
  window.__bmcFilter = true;

  var ACC = ['scarves', 'buffs-gaiters', 'gloves'];
  var CAPS = ['baseball-caps', 'snapbacks', 'trucker-caps', 'golf-caps', 'flat-caps'];
  function list(v) { return (v || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean); }
  function same(a, b) { return a.length === b.length && a.every(function (x) { return b.indexOf(x) > -1; }); }
  function unpend() { document.documentElement.classList.remove('bmc-pending'); }

  function init() {
    var boxes = [].slice.call(document.querySelectorAll('[data-bmc-filter]'));
    if (!boxes.length) { unpend(); return; }
    var b0 = boxes[0];
    var handle = b0.getAttribute('data-handle') || 'all';
    var preset = list(b0.getAttribute('data-preset'));
    var hasAcc = b0.getAttribute('data-acc') === '1';
    var tagColour = b0.getAttribute('data-tagcolour') || '';
    var url = new URL(location.href);
    var hasParams = url.searchParams.has('style') || url.searchParams.has('colour');
    var sortBy = url.searchParams.get('sort_by') || 'price-ascending';
    var view = url.searchParams.get('view') || '';
    var perPage = view === 'vall' ? 100000 : view === 'v24' ? 24 : 12;
    var state = {
      style: url.searchParams.has('style') || !preset.length ? list(url.searchParams.get('style')) : preset.slice(),
      colour: list(url.searchParams.get('colour'))
    };
    if (!hasParams && tagColour && !state.colour.length) state.colour = [tagColour];
    var base = preset.length ? 'all' : handle;
    var cache = null;

    function filtering() { return preset.length ? (hasParams || state.colour.length > 0) : (state.style.length + state.colour.length > 0); }

    function sync() {
      boxes.forEach(function (box) {
        box.querySelectorAll('input[data-group]').forEach(function (i) {
          i.checked = state[i.getAttribute('data-group')].indexOf(i.value) > -1;
        });
        var n = state.style.length + state.colour.length;
        var c = box.querySelector('[data-bmc-count]');
        if (c) c.textContent = n ? '(' + n + ')' : '';
        var clr = box.querySelector('[data-bmc-clear]');
        if (clr) clr.hidden = !n;
      });
    }

    function buildUrl(path) {
      var u = new URL(path, location.origin);
      if (state.style.length) u.searchParams.set('style', state.style.join(','));
      if (state.colour.length) u.searchParams.set('colour', state.colour.join(','));
      if (url.searchParams.get('sort_by')) u.searchParams.set('sort_by', url.searchParams.get('sort_by'));
      return u.pathname + u.search;
    }

    function load() {
      if (cache) return Promise.resolve(cache);
      var items = [];
      function page(n) {
        return fetch('/collections/' + base + '?view=bmcfilter&sort_by=' + encodeURIComponent(sortBy) + '&page=' + n, { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var wrap = doc.getElementById('bmcf-data');
            if (!wrap) return;
            [].forEach.call(wrap.children, function (li) {
              if (/(^|\|)bmc-fee(\||$)/.test(li.getAttribute('data-tags') || '')) return;
              items.push(li);
            });
            var pages = parseInt(wrap.getAttribute('data-pages'), 10) || 1;
            if (n < pages && n < 5) return page(n + 1);
          });
      }
      return page(1).then(function () { cache = items; return items; });
    }

    function tagsOf(li) { return (li.getAttribute('data-tags') || '').split('|'); }
    function isAcc(li) {
      var styles = tagsOf(li).filter(function (t) { return t.indexOf('style-') === 0; }).map(function (t) { return t.slice(6); });
      return styles.length > 0 && styles.every(function (s) { return ACC.indexOf(s) > -1; });
    }
    function matches(li) {
      var tags = tagsOf(li);
      var okS = !state.style.length || state.style.some(function (s) { return tags.indexOf('style-' + s) > -1; });
      var okC = !state.colour.length || state.colour.some(function (c) { return tags.indexOf('colour-' + c) > -1; });
      /* the colour must have a real photo; colours without one are left off the product page too */
      if (okC && state.colour.length && li.getAttribute('data-vimg')) okC = !!colourImage(li);
      return okS && okC;
    }
    function tier(li) {
      var tags = tagsOf(li);
      if (tags.indexOf('bmc-accessory') > -1) return 3;
      var styles = tags.filter(function (t) { return t.indexOf('style-') === 0; }).map(function (t) { return t.slice(6); });
      if (!styles.length || styles.some(function (s) { return CAPS.indexOf(s) > -1; })) return 0;
      if (styles.every(function (s) { return ACC.indexOf(s) > -1; })) return 3;
      if (styles.indexOf('beanies') > -1) return 2;
      return 1;
    }
    function order(hits) {
      if (sortBy !== 'price-ascending') return hits;
      var groups = [[], [], [], []];
      hits.forEach(function (li) { groups[tier(li)].push(li); });
      return groups[0].concat(groups[1], groups[2], groups[3]);
    }
    // Same colour words as card-product.liquid: show the photo of the colour being filtered on.
    var KW = {
      'camo': 'camo,forrest,leaflock,oakshade,woodland,pixel,digital,desert,leaf,jungle,oak,pine,thorn',
      'pattern-print': 'sa flag,south africa,aztec,fruit,tropical,stripe,multi,heliconia,vintage,arrow,flag',
      'black': 'black', 'white': 'white,ivory,cream',
      'grey': 'grey,gray,charcoal,melange,graphite,heather,slate',
      'blue': 'navy,royal,denim,sky,aqua,turquoise,turquise,teal,powder,cobalt,airforce,marine,petrol,sea blue,arctic,jean,blue',
      'red': 'red,burgundy,burgandy,maroon', 'pink': 'pink,fuchsia,cerise,raspberry,coral',
      'purple': 'purple,lilac', 'orange': 'orange,rust,peach,copper',
      'yellow': 'yellow,lemon,mustard,gold,sunflower,sunshine,honey',
      'green': 'green,olive,bottle,emerald,lime,mint,sage,military,fatigue,kelly,bush',
      'brown': 'brown,chocolate,choc,coffee,tan,camel,tobacco,cork',
      'beige-khaki': 'khaki,stone,sand,natural,taupe'
    };
    function colourImage(li) {
      if (!state.colour.length) return null;
      var raw = li.getAttribute('data-vimg') || '';
      var vs = raw.split('^').filter(Boolean).map(function (s) {
        var p = s.split('~');
        return { t: p[0], w: +p[2] || 0, h: +p[3] || 0, u: p.slice(4).join('~') };
      });
      if (!vs.length) return null;
      for (var c = 0; c < state.colour.length; c++) {
        var kws = (KW[state.colour[c]] || '').split(',').filter(Boolean);
        for (var pass = 0; pass < 2; pass++) {
          for (var i = 0; i < vs.length; i++) {
            var t = pass === 0 ? vs[i].t.split('/')[0] : vs[i].t;
            for (var k = 0; k < kws.length; k++) if (t.indexOf(kws[k]) > -1) return vs[i];
          }
        }
      }
      return null;
    }
    function applyColour(li) {
      var hit = colourImage(li);
      if (!hit) return;
      var img = li.querySelector('.card__media img:not(.hover-img)');
      if (!img) return;
      var u = hit.u, j = u.indexOf('?') > -1 ? '&' : '?';
      var srcset = [165, 360, 533, 720].map(function (w) { return u + j + 'width=' + w + ' ' + w + 'w'; }).join(', ');
      var hov = li.querySelector('.card__media img.hover-img');
      if (hov) hov.remove();
      img.loading = 'eager';
      /* keep the cap's normal photo on screen until the colour photo has loaded, so a card is never an empty block */
      var pre = new Image();
      pre.sizes = img.sizes || '(min-width: 990px) 360px, 50vw';
      pre.onload = function () {
        img.srcset = srcset;
        img.src = u + j + 'width=533';
      };
      pre.srcset = srcset;
      pre.src = u + j + 'width=533';
    }
    function wakeImages(root) {
      root.querySelectorAll('img.loading-image').forEach(function (img) {
        img.classList.remove('loading-image');
        img.classList.add('loaded-image');
      });
    }

    function render(paged) {
      var grid = document.getElementById('product-grid');
      if (!grid) { unpend(); return; }
      if (!paged) document.documentElement.classList.add('bmc-filtering');
      grid.classList.add('bmc-filter-loading');
      load().then(function (items) {
        var hits = order(items.filter(matches));
        if (grid.tagName !== 'UL') {
          var ul = document.createElement('ul');
          ul.id = 'product-grid';
          ul.className = 'grid product-grid view-mode grid-view-filter grid--1-col-mobile grid--3-col-desktop grid--2-col-tablet-down';
          grid.parentNode.replaceChild(ul, grid);
          grid = ul;
        }
        var shown = 0;
        var more = document.querySelector('.bmc-filter__more');
        function showNext() {
          var next = paged ? hits.slice(shown, shown + perPage) : hits.slice(shown);
          var frag = document.createDocumentFragment();
          next.forEach(function (li) { var c = li.cloneNode(true); applyColour(c); frag.appendChild(c); });
          wakeImages(frag);
          grid.appendChild(frag);
          shown += next.length;
          if (more) {
            var left = hits.length - shown;
            more.hidden = left <= 0;
            more.textContent = 'Show more (' + left + ' more)';
          }
          wakeImages(grid);
        }
        grid.innerHTML = '';
        if (paged && hits.length > perPage && !more) {
          more = document.createElement('button');
          more.type = 'button';
          more.className = 'button bmc-filter__more';
          more.addEventListener('click', showNext);
          grid.parentNode.insertBefore(more, grid.nextSibling);
        }
        showNext();
        if (!hits.length) grid.innerHTML = '<li class="bmc-filter__empty">No products match these filters. Try removing one.</li>';
        grid.classList.remove('bmc-filter-loading');
        var note = document.querySelector('.bmc-filter__results');
        if (!note) {
          note = document.createElement('p');
          note.className = 'bmc-filter__results';
          grid.parentNode.insertBefore(note, grid);
        }
        note.textContent = hits.length + (hits.length === 1 ? ' product' : ' products');
        var hide = ['.pagination-wrapper', '.custom-page-progress-bar', '.load_more_btn'];
        if (!paged) hide.push('.bmc-per-page');
        var aj = document.getElementById('AjaxinatePagination');
        if (aj) aj.remove();
        hide.forEach(function (s) {
          document.querySelectorAll('#ProductGridContainer ' + s + ', ' + s).forEach(function (el) { el.style.display = 'none'; });
        });
        unpend();
      }).catch(function () { grid.classList.remove('bmc-filter-loading'); unpend(); });
    }

    function onChange(e) {
      var i = e.target;
      if (!i.matches || !i.matches('input[data-group]')) return;
      var g = i.getAttribute('data-group');
      var arr = state[g].filter(function (v) { return v !== i.value; });
      if (i.checked) arr.push(i.value);
      state[g] = arr;
      sync();
      if (preset.length) {
        // On a style page (e.g. Truckers): removing its own style clears every filter.
        var removedPreset = preset.some(function (p) { return state.style.indexOf(p) < 0; });
        if (removedPreset) { location.assign('/collections/all'); return; }
        if (same(state.style, preset) && !state.colour.length) { location.assign('/collections/' + handle); return; }
        location.assign(buildUrl('/collections/all'));
        return;
      }
      if (!state.style.length && !state.colour.length) { location.assign('/collections/' + handle); return; }
      history.replaceState(null, '', buildUrl('/collections/' + handle));
      var m = document.querySelector('.bmc-filter__more');
      if (m) m.remove();
      render(false);
    }

    boxes.forEach(function (box) {
      box.addEventListener('change', onChange);
      var clr = box.querySelector('[data-bmc-clear]');
      if (clr) clr.addEventListener('click', function () { location.assign(preset.length ? '/collections/all' : '/collections/' + handle); });
    });
    sync();
    if (filtering()) render(false);
    else if (!preset.length && hasAcc && sortBy === 'price-ascending') render(true); // caps first, accessories last
    else unpend();
  }

  setTimeout(unpend, 8000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
